
<div>
    <c-inspection-data
        :has-data    = "true"
        :show-header = "false"
        :show-body   = "false"
        :show-border = "true"
        title        = "LG Smart"
    >
        <template v-slot:content>
            <div class="v-flex mt-0 pa-3 pb-1">
                <div style="width: 66.6%" class="pr-4">
                    <div class="v-flex">
                        <p-lg-smart-sensor
                            class="w-50 mr-2"
                            :label      = "escalator ? 'Gateway der Fahrtreppe' : 'Gateway auf dem Fahrkorbdach'"
                            :inspection = "inspection"
                            :sensor     = "lgs.gateway"
                        />

                        <p-lg-smart-sensor
                            class="w-50 ml-2"
                            :label      = "escalator ? 'Sensor Fahrtreppe' : 'Sensor Fahrkorbtür 1'"
                            :inspection = "inspection"
                            :sensor     = "lgs.door_1"
                        />
                    </div>

                    <div class="v-flex mt-4" v-if="escalator">
                        <f-read-only-field
                            class   = "w-50 mr-2"
                            label   = "Fahrtrichtung"
                            :value  = "startDirection"
                            :filled = "true"
                        />
                    </div>

                    <div class="v-flex mt-4" v-else>
                        <p-lg-smart-sensor
                            class="w-50 mr-2"
                            label       = "Sensor Fahrkorbtür 2"
                            :inspection = "inspection"
                            :sensor     = "lgs.door_2"
                        />

                        <p-lg-smart-sensor
                            class="w-50 ml-2"
                            label       = "Sensor Hauptzugangsebene"
                            :inspection = "inspection"
                            :sensor     = "lgs.reference"
                        />
                    </div>
                </div>
                <div style="width: 33.3%; height: 100%">
                    <div class="sensor-title primary--text">
                        Montage
                    </div>

                    <div class="lm-border pa-3 pt-0" style="height: 544px">
                        <v-switch
                            v-if="!escalator"
                            class="mt-3"
                            label="Durchladung"
                            v-model="assembly.throughLoading"
                            dense
                            hide-details
                            readonly
                        />

                        <v-switch
                            v-if="!escalator"
                            label="Übereckausladung"
                            v-model="assembly.uebereckausladung"
                            dense
                            hide-details
                            readonly
                        />

                        <v-switch
                            :class="{ 'mt-3': escalator }"
                            label="3-fach Steckdose notwendig"
                            v-model="assembly.addSocket"
                            dense
                            hide-details
                            readonly
                        />

                        <f-read-only-field
                            class="mt-10"
                            label = "LG Smart Montage"
                            :value = "assemblyHint"
                            :filled = "true"
                        />

                        <div style="font-size: 14px; margin-top: 54px">Bemerkungen</div>
                        <div class="notice lm-border pa-2" >
                            {{ assembly.comment }}
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </c-inspection-data>
</div>
